const __filename = "/lib/therapist_profile/desktop.js", __dirname = "/lib/therapist_profile";
import startShared from './shared.js'

export default function () {
  startShared()

  document.addEventListener('DOMContentLoaded', () => {
    const scrolledHeader = document.querySelector('#js__scrolledHeader')
    const observedEle = document.querySelector('#js__observed')

    new IntersectionObserver(entries => {
      entries.forEach(entry => {
        scrolledHeader.classList.toggle('scrolled', !entry.isIntersecting)
      })
    }).observe(observedEle)
  })
}
